// -- React Libraries
import React from 'react';

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Resources
import RunningIcon from '../../../image/running.png';
import PauseIcon from '../../../image/pause.png';

export default class CampaignState extends React.Component {
    constructor (props) {
        super(props);

        this.ID = props.id;
        this.Region = props.region;
        this.IsRunning = false;

        if (Array.isArray(props.data)) {
            this.IsRunning = (props.data.find(data => data.servingStatus.toString().toUpperCase() === "RUNNING") != null);
        }
        else {
            this.IsRunning = props.data.servingStatus.toString().toUpperCase() === "RUNNING";
        }
    }

    render() {
        const _changeState = function () {
            this.props.onChange(this.Region, !this.IsRunning);
        }.bind(this);

        return (
            <StyleWrapper className={this.props.className}>
                <input type="checkbox" 
                    checked={this.IsRunning}
                    // id={this.prop.item.pCid + ' ' + this.prop.item.dCid} 
                    id={this.props.id}
                    onChange={ () => { _changeState() } }
                />
                {/* <label htmlFor={this.prop.item.pCid + ' ' + this.prop.item.dCid} className="switch-wrapper"> */}
                <label className="switch-wrapper" htmlFor={this.props.id}>
                    <span>
                        <img src={ RunningIcon } className="running"/>
                        <img src={ PauseIcon } className="paused"/>
                    </span>

                    <p className="running"></p>
                    <p className="paused"></p>
                </label>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignState/index.js